import styled, { createGlobalStyle } from 'styled-components';

import { transitions, typography, breakpoints } from '../../theme';

export const GlobalStyle = createGlobalStyle`
  html {
    background: ${props => props.backgroundColor};
    color: ${props => props.foregroundColor};
    font-size: ${typography.REM_IN_VW}vw;
    letter-spacing: ${typography.LETTER_SPACING}rem;
    transition: background ${transitions.COLOR}, color ${transitions.COLOR};

    @media screen and (min-width: ${(typography.REM_MAX /
      typography.REM_IN_VW) *
      100}px) {
      font-size: ${typography.REM_MAX}px;
    }

    @media screen and (max-width: ${(typography.REM_MIN /
      typography.REM_IN_VW) *
      100}px) {
      font-size: ${typography.REM_MIN}px;
    }

    *, *:before, *:after {
      box-sizing: border-box;
    }

    a {
      color: inherit;
      text-decoration: none;
      border-bottom: solid 2px currentColor;
    }

    p, h1, h2, h3, h4, h5, h6, ul, ol {
      font-size: inherit;
      font-weight: normal;
      line-height: ${typography.LINE_HEIGHT}rem;
      margin: ${typography.LINE_HEIGHT}rem 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    h1, h2, h3, h4, h5, h6 {
      text-align: center;
      text-transform: uppercase;
    }

    p {
      margin: 0;
      text-indent: ${typography.LINE_HEIGHT * 1.5}rem;

      &:last-of-type {
        margin-bottom: ${typography.LINE_HEIGHT}rem;
      }
    }

    h1 + p,
    h2 + p,
    h3 + p,
    h4 + p,
    h5 + p,
    h6 + p,
    p:first-of-type {
      margin-top: ${typography.LINE_HEIGHT}rem;
      text-indent: 0;
    }

    ul, ol {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      margin: 0;
      padding: 0;
    }
  }

  body {
    font-size: ${typography.FONT_SIZE}rem;
    -webkit-font-smoothing: antialiased;
    line-height: ${typography.LINE_HEIGHT}rem;
    visibility: visible !important;
  }
`;

export const Wrapper = styled.section`
  @media ${breakpoints.MOBILE__MQ} {
    bottom: 0;
    left: 0;
    perspective: 90vw;
    perspective-origin: center;
    position: fixed;
    right: 0;
    top: 0;
    transform-style: preserve-3d;
  }
`;

export const Content = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transform-style: preserve-3d;

  @media ${breakpoints.MOBILE__MQ} {
    overflow: auto;
  }
`;
